import { render, staticRenderFns } from "./PermissionManage.vue?vue&type=template&id=6a7d9cc0&scoped=true&"
import script from "./PermissionManage.vue?vue&type=script&lang=js&"
export * from "./PermissionManage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a7d9cc0",
  null
  
)

export default component.exports